import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import noop from 'lodash/noop'
import { IconAction, TimesIcon } from 'src/components'
import LabeledInput from '../LabeledInput'
import styles from './ClearableInput.scss'

/**
 * The [Input](#Input) component with a label.
 */
const ClearableInput = ({ className, style, value, onChange, ...domProps }) => (
  <div className={classnames(styles.clearable, className)} style={style}>
    <LabeledInput {...domProps} className={styles.input} value={value} onChange={onChange} />
    <div className={classnames(styles.clear, { [styles.visible]: value !== '' })}>
      <IconAction icon={TimesIcon} onClick={() => onChange('')} />
    </div>
  </div>
)

ClearableInput.defaultProps = {
  onChange: noop,
}

ClearableInput.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default ClearableInput
